var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#fff","padding":"16px 0 0px 16px","overflow":"hidden"}},_vm._l((_vm.items),function(i){return _c('title_value',{key:i.title,attrs:{"title":i.title,"value":i.value.toString()}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }